var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.sponsor && _vm.sponsor.title !== null)?_c('div',{staticClass:"portrait position-relative",style:('background-image: url(' + _vm.sponsor.image + ');')},[_c('a',{staticClass:"clickable-area",attrs:{"href":_vm.sponsor.url,"target":"_blank"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }